import { Helmet } from 'react-helmet-async';

function SEO({ title, description, url, image }) {
  // Valores por defecto si la página no envía propiedades específicas
  const defaultTitle = "SITEV | Software para Centros de Inspección Técnica Vehicular";
  const defaultDesc = "Optimice su CITV con SITEV. Software integral para centros de inspección técnica vehicular en Perú. Cumple normativas MTC, incluye Facturación Electrónica. Soporte técnico permanente.";
  const defaultUrl = "https://www.jcsistemasperu.com";
  const defaultImage = "https://www.jcsistemasperu.com/images/sitev_seo.webp";

  return (
    <Helmet>
        {/* Metadatos Estándar */}
        <title>{title ? `${title} | SITEV` : defaultTitle}</title>
        <meta name="title" content={title ? `${title} | SITEV` : defaultTitle}/>
        <meta name="description" content={description || defaultDesc} />
        <link rel="canonical" href={url || defaultUrl} />
        <meta name="robots" content="index, follow" />
    
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={url || defaultUrl} />
        <meta property="og:title" content={title || defaultTitle} />
        <meta property="og:description" content={description || defaultDesc} />
        <meta property="og:image" content={image || defaultImage} />

        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title || defaultTitle} />
        <meta name="twitter:description" content={description || defaultDesc} />
        <meta name="twitter:image" content={image || defaultImage} />
    </Helmet>
  );
}

export default SEO;